module.exports = __webpack_public_path__ + "img/mickey132.8110a0ba.jpg";